import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Divider,
  Link,
  useTheme,
} from '@material-ui/core';
import Page from 'src/components/Page';
import gradients from 'src/utils/gradients';
import LoginForm from './LoginForm';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 2)
  },
  card: {
    width: theme.breakpoints.values.md,
    backgroundColor: theme.palette.ciam.card.backgroundColor,
    border: '1px solid',
    borderColor: theme.config.layout.secondary.background,
    borderRadius: 15,
    overflow: 'hidden',
    maxWidth: '100%',
    display: 'flex',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse'
    },
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%',
      [theme.breakpoints.down('sm')]: {
        flexBasis: '100%',
        width: '100%',
      },
    }
  },
  content: {
    padding: theme.spacing(8, 4, 3, 4),
    '&.media': {
      borderTopRightRadius: theme.palette.spiga.card.borderRadius,
      borderBottomRightRadius: theme.palette.spiga.card.borderRadius,
      [theme.breakpoints.down('sm')]: {
        borderTopRightRadius: theme.palette.spiga.card.borderRadius,
        borderTopLeftRadius: theme.palette.spiga.card.borderRadius,
        borderBottomRightRadius: 0,
      }
    }
  },
  media: {
    borderTopRightRadius: theme.palette.spiga.card.borderRadius,
    borderBottomRightRadius: theme.palette.spiga.card.borderRadius,
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    },
  },
  mediaAction: {
    width: '100%',
    height: '100%'
  },
  icon: {
    backgroundImage: gradients.green,
    color: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    position: 'absolute',
    top: -32,
    left: theme.spacing(3),
    height: 64,
    width: 64,
    fontSize: 32
  },
  loginForm: {
    marginTop: theme.spacing(3)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  person: {
    marginTop: theme.spacing(2),
    display: 'flex'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  stdLink: {
    color: theme.palette.spiga.typos.color,
    paddingRight: '15px',
    textDecoration: 'none',
  },
  stdLinkRight: {
    color: theme.palette.spiga.typos.color,
    paddingLeft: '15px',
    textDecoration: 'none',
    float: 'right',
  },
  mobileContent: {
    marginBottom: '50px',
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block'
    },
  },
  loginTitle: {
    color: theme.palette.ciam.card.color,
  },
  submitButton: {
    marginTop: theme.spacing(2),
    ...theme.palette.spiga.button
  },
  signInButton: {
    position: 'absolute',
    bottom: '78px',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      bottom: 'auto',
    },
  },
  submitButtonRed: {
    backgroundColor: theme.palette.spiga.red,
  },
}));

function Login() {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Page
      className={classes.root}
      title="Login"
    >
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <Typography
            gutterBottom
            variant="h1"
            className={classes.loginTitle}
            dangerouslySetInnerHTML={{ __html: theme.config.strings.tagline }}
          />
          <LoginForm className={classes.loginForm} />
          <Divider className={classes.divider} />
          <Link
            className={classes.stdLink}
            align="center"
            color="secondary"
            component={RouterLink}
            to="/auth/recover"
            underline="always"
            variant="subtitle2"
          >
            {theme.config.strings.recoverPasswordLabel}
          </Link>
          <Link
            className={classes.stdLinkRight}
            align="center"
            color="secondary"
            component={RouterLink}
            to="/auth/register"
            underline="always"
            variant="subtitle2"
          >
            <b>{theme.config.strings.registerLabel}</b>
          </Link>
        </CardContent>
        <CardMedia
          className={`${classes.content} media`}
          image={theme.config.mainImagePath}
          title={theme.config.title}
        />
      </Card>
    </Page>
  );
}

export default Login;
